import React from 'react';
import { AmplifyAuthenticator, AmplifySignIn, AmplifySignUp } from '@aws-amplify/ui-react';
import { makeStyles, Theme, createStyles, Typography } from '@material-ui/core';
import { useTranslation } from "react-i18next"


const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
    },
    billboard: {
        color: "#FFF",
        backgroundColor: "#000A",
        width: "100%",
        minHeight: "400px",
        display: "flex",
        flexWrap: "wrap",
        padding: theme.spacing(1)
    },
    title: {
        flexGrow: 1,

    },
    main: {
        margin: "8px",
    }
  }),
);


interface Props {
}

function Welcome(props: Props) {

    const classes = useStyles()
    const [t, i18n] = useTranslation()

    return (
        <div className={classes.root}>
            <div className={classes.billboard}>
                <div className={classes.title}>
                    <Typography variant="h5" component="h2">
                        {t("message.welcome.message")}
                    </Typography>
                    <img alt="logo" src="/logo.png"/>
                </div>
                <div>
                    <AmplifyAuthenticator lang={i18n.language}>
                        <AmplifySignIn
                            slot="sign-in"
                            usernameAlias="email"
                        >
                        </AmplifySignIn>
                        <AmplifySignUp 
                            slot="sign-up"
                            usernameAlias="email"
                            formFields={[
                                {
                                    type: "email",
                                },
                                {
                                    type: "password"
                                },
                            ]}
                        >
                        </AmplifySignUp>
                    </AmplifyAuthenticator>
                </div>
            </div>
            <div className={classes.main}>
            </div>
        </div>
    )
}

export default Welcome